import { SxProps } from "@mui/material";
import { colors } from "../../../../../../common/theme";

// Header styles
const remainingOrderCard: SxProps = {
  marginBottom: "10px",
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  color: colors.neutral["500"],
  gap: "7px",
};

const remainingOrderBadge: SxProps = {
  borderRadius: "10px",
  color: colors.primary["500"],
  backgroundColor: colors.primary["50"],
  padding: "0px 5px",
  fontWeight: "400",
  fontSize: "12px",
  lineHeight: "20px",
  marginTop: "15px",
};

const remainingOrderTitle: SxProps = {
  fontSize: "14px",
  fontWeight: "700",
  lineHeight: "20px",
  letterSpacing: "0px",
  margin: "24px 0 0 0",
  color: colors.neutral["500"],
};

const headerButtonsContainer: SxProps = {
  marginLeft: 'auto',
  display: 'flex',
  gap: 1,
};

const resetButton: SxProps = {
  color: 'primary.main',
  '&:hover': {
    bgcolor: 'primary.light',
    color: 'primary.dark',
  },
};

const refreshButton: SxProps = {
  color: 'primary.main',
  '&:hover': {
    bgcolor: 'primary.light',
    color: 'primary.dark',
  },
};

// Search form styles
const searchFormContainer: SxProps = {
  py: 2,
  bgcolor: "background.paper",
  borderRadius: 1,
};

const searchFieldContainer: SxProps = {
  position: 'relative',
};

const clearButton: SxProps = {
  position: 'absolute',
  right: 8,
  top: 8,
  zIndex: 1,
  bgcolor: 'background.paper',
  '&:hover': { bgcolor: 'action.hover' }
};

const actionDateContainer: SxProps = {
  display: 'flex',
  alignItems: 'center',
  mt: 0.5,
};

const noActionDateText: SxProps = {
  fontSize: '0.75rem',
  color: 'text.secondary',
};

const statusApplyButton: SxProps = {
  justifyContent: 'center',
  py: 1,
  '&:hover': { bgcolor: 'action.hover' }
};

const statusApplyLink: SxProps = {
  textDecoration: 'none',
  color: 'primary.main',
  fontWeight: 500
};

// Table styles
const tableContainer: SxProps = {
  border: "1px solid",
  borderRadius: "8px",
  borderColor: colors.neutral["200"],
};

const tableRow: SxProps = {
  "&:last-child td, &:last-child th": { border: 0 },
};

const tableHeader: SxProps = {
  display: "table-cell",
  textAlign: "left",
  verticalAlign: "middle",
  fontWeight: "700",
  fontSize: "14px",
  lineHeight: "20px",
  color: colors.neutral["900"],
};

const tableSortLabel: SxProps = {
  width: '100%',
  justifyContent: 'space-between',
  '& .MuiTableSortLabel-icon': {
    marginLeft: 'auto'
  }
};

const orderNo: SxProps = {
  color: colors.neutral["500"],
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "20px",
};

const pagination: SxProps = {
  borderTop: "1px solid",
  borderTopColor: colors.neutral["200"],
};

// Error display styles
const errorContainer: SxProps = {
  mb: 2,
  p: 2,
  bgcolor: "error.light",
  color: "error.contrastText",
  borderRadius: 1,
};

// Utility styles
const progress: SxProps = {
  display: "flex",
};

const classes = {
  // Header
  remainingOrderBadge,
  remainingOrderCard,
  remainingOrderTitle,
  headerButtonsContainer,
  resetButton,
  refreshButton,
  
  // Search form
  searchFormContainer,
  searchFieldContainer,
  clearButton,
  actionDateContainer,
  noActionDateText,
  statusApplyButton,
  statusApplyLink,
  
  // Table
  tableContainer,
  tableHeader,
  tableSortLabel,
  tableRow,
  orderNo,
  pagination,
  
  // Error
  errorContainer,
  
  // Utility
  progress,
};

export default classes;
